/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState, start_hour, end_hour } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function OrderAdd(props) {
  const { login, onCloseAddPop, tcidParent } = props;
  const token = localStorage.getItem("token");
  const [tcid, setTcid] = useState(tcidParent);
  const [name, setName] = useState("");
  const [yoil, setYoil] = useState("");
  const [open, setOpen] = useState("");
  const [close, setClose] = useState("");
  const [state, setState] = useState("Y");
  const [tmcd, setTmcd] = useState("");
  const [showMemberSearch, setShowMemberSearch] = useState(false);
  const [sdate, setSdate] = useState(moment().format("YYYY-MM-DD HH:mm:00"));
  const [edate, setEdate] = useState(
    moment().add(3, "hours").format("YYYY-MM-DD HH:mm:00")
  );

  const onSubmit = async () => {
    // console.log("tcid=" + tcid);
    // console.log("tmcd=" + tmcd);
    // console.log('sdate='+sdate);
    // console.log('edate='+edate);
    // console.log('state='+state);
    let result = await axios.post(
      configState.api + "/gympass_admin/smartkey_add",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        tcid: tcid,
        tmcd: tmcd,
        sdate: sdate,
        edate : edate,
        state: state
      }
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "등록되었습니다.", showCloseButton: true }).then(
        (result) => {
          onCloseAddPop();
        }
      );
    }
  };

  // MemberSearch
  const onShowMemberSearchClick = () => {
    setShowMemberSearch(true);
  };

  const onHideMemberSearchClick = () => {
    setShowMemberSearch(false);
  };

  const onAfterMemberSearchClick = (params) => {
    const { id, name } = params;
    setName(name);
    setTmcd(id);
  };

  return (
    <Box>
      
      {/* 사용자 찾기 팝업 */}
      <Dialog
        open={showMemberSearch}
        onClose={() => {}}
        fullWidth={true}
        maxWidth="md"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>회원찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideMemberSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <MemberSearch
          login={login}
          tcidParent={tcid}
          onAfterMemberSearchClick={onAfterMemberSearchClick}
          onHideMemberSearchClick={onHideMemberSearchClick}
        />
      </Dialog>

      <Box
        css={css`
          padding: 20px 60px;
        `}
      >
        {/* 센터명 */}
        <CenterSelect login={login} tcidParent={tcid} setTcidParent={setTcid} />

        {/* 고객명 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="name"
            label="고객명"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={name}
          ></TextField>

          <Button
            variant="contained"
            sx={{ ml: 1 }}
            onClick={onShowMemberSearchClick}
          >
            조회
          </Button>
        </Box>

        <Box sx={{ mt: 1 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
            <DateTimePicker
              label="시작시간"
              value={sdate}
              onChange={(newValue) => {
                setSdate(moment(newValue).format("YYYY-MM-DD HH:mm:00"));
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Box>

        <Box sx={{ mt: 1 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
            <DateTimePicker
              label="종료시간"
              value={edate}
              onChange={(newValue) => {
                setEdate(moment(newValue).format("YYYY-MM-DD HH:mm:00"));
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Box>

        <Box sx={{ mt: 1 }}>          

          {/* 상태 */}
          <FormControl
            fullWidth
            css={css`
              margin-top: 10px;
            `}
          >
            <FormLabel>상태</FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-radio-buttons-group-label"
              name="state"
              onChange={(e) => setState(e.target.value)}
              value={state}
            >
              <FormControlLabel value="Y" control={<Radio />} label="Y" />
              <FormControlLabel value="" control={<Radio />} label="N" />
            </RadioGroup>
          </FormControl>
        </Box>

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            등록완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onCloseAddPop}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default OrderAdd;
